import Campaign from '../store/Campaign';
import getCampaignStore from '../store/store';
import Journey from '../store/Journey';
import { CampaignEndSignal } from '../store/schema/CampaignEndSignal';
import { CampaignId } from 'mini-campaign-bootstrap/lib/schema/CampaignId';
import { isMiniHostAppCampaignEnabled } from 'mini-campaign-bootstrap/lib/utils/isMiniHostAppCampaignEnabled';
import { observer } from 'mobx-react-lite';
import { useComponentWillUnmount } from 'mini-hooks/lib/useComponentWillUnmount';
import { useEffect } from 'react';

/**
 *  Defines interface for CampaignUnit Props
 */
interface CampaignUnitProps<T> {
    campaign: Campaign<T>;
    viewProps: T;
    journey?: Journey;
    isPreview?: boolean;
}

/**
 * React Component to render a campaign unit
 */
const CampaignUnitComponent = <T extends {}>(props: CampaignUnitProps<T>): JSX.Element => {
    const { campaign, journey, viewProps, isPreview } = props;

    useEffect(() => {
        if (
            isMiniHostAppCampaignEnabled(campaign.getRemoteCampaignId() as CampaignId) &&
            !isPreview
        ) {
            journey ? journey.start() : campaign.start();
        }
    }, [journey, campaign]);

    useComponentWillUnmount(() => {
        !isPreview && campaign.end(CampaignEndSignal.OnUnmount);
    });

    const { campaignVisibleMap } = getCampaignStore();
    const isCampaignVisible = campaignVisibleMap?.get(campaign);

    useEffect(() => {
        if (isCampaignVisible) {
            campaign.ready();
        }
    }, [isCampaignVisible, campaign]);

    /**
     * Check dependencies on Campaign View Store to render the Campaign
     */
    if (isCampaignVisible || isPreview) {
        return campaign.render(viewProps);
    }
    return null;
};

const CampaignUnit = observer(CampaignUnitComponent);

export { CampaignUnit };
